/// <reference path="../typings/index.d.ts" />

declare var chrome: any;
declare var swal: any;
namespace App.Modulos {
    export class BotConta {
        public static inicializar() {
            var botConta = new App.BotConta();
            botConta.inicializarEventos();
        }
    }
}
namespace App {
    export class BotConta {
        private ajax: IAjax;
        private conta: IConta = {};
        private sessionId: number = null;
        public static players: any = null;
        private elBtSnipar: LaddaButtonLoading = null;
        private elBtPararSniper: LaddaButtonLoading = null;
        private elBtFecharSniper: LaddaButtonLoading = null;
        private elFormSniper: JQuery = $("#formFiltroSniper");

        private objSelect2: ISelect2 = null;
        private filtrosEa: FiltrosEa = null;

        private socketClientBot: any = null;
        private comunicacao: Comunicacao = null;

        public static cronometro: any = {};
        public agendamentos: any = {};
        private sniperLogs: ISniperLog = null;
        private tentativaAtual: number = 0;

        public inicializarEventos() {
            this.ajax = new App.Ajax();
            var objSocketIo = new SocketIo();
            this.socketClientBot = objSocketIo.inicializarCampo("http://localhost:5000", App.Util.usuario.id, App.Util.usuario.api_token);
            this.comunicacao = new Comunicacao(this.socketClientBot);
            this.inicializarComunicacao();
            this.sniperLogs = new SniperLog($('.sniper-logs'), $('.limpar-log'), $('.load-logs'));

            this.elBtSnipar = new LaddaButtonLoading();
            this.elBtSnipar.inicializarCampo("#btnSnipar");
            this.elBtPararSniper = new LaddaButtonLoading();
            this.elBtPararSniper.inicializarCampo("#btnPararSniper");
            this.elBtFecharSniper = new LaddaButtonLoading();
            this.elBtFecharSniper.inicializarCampo("#btnFecharSniper");

            $("#btnSnipar").on('click', (e) => { this.aoClicarEmIniciarSniper(e); });
            $("#btnPararSniper").on('click', (e) => { this.aoClicarEmPararSniper(e); });
            $("#btnFecharSniper").on('click', (e) => { this.aoClicarEmFecharSniper(e); });

            this.objSelect2 = new Select2();
            this.getPlayers(() => {
                this.continuarInicializacao();
            });
        }
        private inicializarComunicacao() {
            this.comunicacao.socket.on('disconnect', () => {
            });
            this.comunicacao.socket.on(Comunicacao.CANAL_RECEIVE, (acao: number, request: any, callback: any = null) => {
                switch (acao) {
                    case Comunicacao.RECEBER_CONFIRMACAO_CONECTADO:
                        console.log("RECEBER_CONFIRMACAO_CONECTADO:: " + acao, request);
                        toastr.success("Sistema está conectado", "Conectado!");
                        break;
                    case Comunicacao.RECEBER_ATUALIZACAO_STATUS:
                        this.atualizarStatusConta(request);
                        break;
                    case Comunicacao.RECEBER_EVENTO:
                        this.receberEvento(request);
                        break;
                    case Comunicacao.RECEBER_STATUS_EXECUCAO:
                        console.log("RECEBER_STATUS_EXECUCAO::", request);
                        this.receberStatusExecucao(request);
                        break;
                }
            });
        }

        private receberEvento(request: IRequestEvento) {
            console.log("receberEvento EVENTO::", request)
            switch (request.evento) {
                case Util.EVENTO_ACAO:
                    this.registrarAcao(request.data);
                    break;
                case Util.EVENTO_EXIBIR_LOG:
                    this.exibirLog(request.data);
                    break;
            }
        }

        private registrarAcao(dados: IDataAcao) {
            console.log("registrarAcao IDataAcao", dados)
            switch (dados.tipo) {
                case Util.EVENTO_TENTATIVA:
                    console.log("🚀 EVENTO_TENTATIVA");
                    this.incrementarTentativa();
                    break
            }
        }

        private exibirLog(dadosLog: IDataLog) {
            console.log("exibirLog dadosLog", dadosLog)
            switch (dadosLog.tipo) {
                case Util.EVENTO_TIPO_COMPRA:
                    var itemPlayer: IItemListagem = dadosLog.data && dadosLog.data.response ? JSON.parse(dadosLog.data.response) : null;
                    this.registrarCompra(itemPlayer, dadosLog.status)
                    break
                case Util.EVENTO_TIPO_ENVIOU_TRANSFERENCIA:
                    if (dadosLog.status) {
                        this.registrarEnvioParaTransferencia();
                    }
                    break
                case Util.EVENTO_TIPO_CAPTCHA:
                    if (dadosLog.status) {
                        this.registrarCaptcha();
                    }

                    break
                case Util.EVENTO_INICIOU_SNIPER:
                    this.sniperLogs.exibirLog("Executando", `Seu sniper está em execução`, "primary")
                    break
                case Util.EVENTO_PAROU_SNIPER:
                    //this.sniperLogs.exibirLog("Sniper Parou", `Seu Sniper terminou de executar `, "primary")
                    break
                case Util.EVENTO_PAROU_SNIPER_LIMITE_ATINGIDO:
                    this.sniperLogs.exibirLog("Limite Atingido", `O limite de compra foi atingido`, "warning")
                    this.pararSniper();
                    break
                case Util.EVENTO_PAROU_CAPACIDADE_LISTAS_ATINGIDA:
                    this.sniperLogs.exibirLog("Lista Cheia", `A capacidade de sua lista foi atingida`, "warning")
                    this.pararSniper();
                    break
                case Util.EVENTO_TIPO_COLOCOU_A_VENDA:
                    var itemPlayer: IItemListagem = dadosLog.data && dadosLog.data.response ? JSON.parse(dadosLog.data.response) : null;
                    var dataRequestVenda: IRequestAddVenda = dadosLog.data && dadosLog.data.request ? JSON.parse(dadosLog.data.request) : null;
                    this.registrarColocadoAVenda(itemPlayer, dataRequestVenda);
                    break
                case Util.EVENTO_TIPO_ERRO:
                    this.sniperLogs.exibirLog("Error", `Um erro ocorreu, se persistir, contate o suporte, PROCESSO: ${dadosLog.data.processo} | ERROR: ${dadosLog.data.error}`, "warning")
                    break
            }
        }

        private registrarCaptcha() {
            this.sniperLogs.exibirLog("Captcha Solicitado", `A Ea está solicitando que você resolva um captcha em sua conta`, "danger")
            this.pararSniper();
        }

        private registrarEnvioParaTransferencia(item: string = "Jogador") {
            this.sniperLogs.exibirLog("Movido para Transferência", `${item} foi movido para sua lista de transfêrencia`, "primary")
        }

        private registrarColocadoAVenda(itemPlayer: IItemListagem, dataRequestVenda: IRequestAddVenda) {
            this.sniperLogs.exibirLog("Colocado à venda", `<b>${itemPlayer.name} (${itemPlayer.rating})</b> colocado à venda por <b>${dataRequestVenda.buyNowPrice}</b>`, "info")
        }

        private registrarCompra(itemPlayer: IItemListagem, comprou: boolean = true, item: string = "Jogador") {
            if (comprou) {
                App.Util.runAudio();
                toastr.success(`Snipado por: " ${itemPlayer.buyNowPrice}, "Parabéns!`);
                this.sniperLogs.exibirLog("snipado", `<b>${itemPlayer.name} (${itemPlayer.rating})</b> snipando por <b>${itemPlayer.buyNowPrice} coins</b>`, "success")
                this.incrementViewQuantidadeCompras();
            } else {
                this.sniperLogs.exibirLog("Disputa Perdida", `<b>${itemPlayer.name} (${itemPlayer.rating})</b> perdido por <b>${itemPlayer.buyNowPrice} coins</b>, isso é comum devido a grande quantidade de pessoas no mundo tentando comprar`, "default")
            }
        }

        private incrementViewQuantidadeCompras() {
            if (App.Util.existeElementoNaPagina($('.quantidade-compras'))) {
                $('.quantidade-compras').html((App.Util.obterInteiroDaString($('.quantidade-compras').html()) + 1).toString());
            }
        }

        private inicializarViewQuantidadeCompras() {
            if (App.Util.existeElementoNaPagina($('.quantidade-compras'))) {
                $('.quantidade-compras').html('0');
            }
        }

        private atualizarStatusConta(conta: IConta) {
            // if (_.contains(Util.ARRAY_STATUS_CONTA_INTERROMPIDA, conta.status)) {
            //     this.elBtSnipar.ocultarLoading();
            //     Util.ocultarLoadingSniperApp();
            // }
        }

        private continuarInicializacao() {
            this.conta.id = parseInt($('input[name=id_conta]').val());
            this.objSelect2.inicializarCampo($('.select2'));
            this.objSelect2.inicializarCampo($('.select-tag'), Util.getOptionsSelectTag());
            this.filtrosEa = new FiltrosEa();
            this.filtrosEa.inicializarEventos();
            this.obterConfiguracoesConta();
            App.Util.ocultarModalPaginaCarregando();
        }

        private obterConfiguracoesConta() {
            this.comunicacao.enviar(Comunicacao.REQUEST_OBTER_CONFIG_CONTAS, { id: this.conta.id }, (response: IRespostaMensagem) => {
                if (response.status) {
                    console.log("obterConfiguracoesConta", response);
                    this.conta = response.result;
                    this.atualizarViewConta(this.conta);
                    App.BotConta.cronometro = new Timer();
                }
            });
        }

        private atualizarViewConta(conta: IConta) {
            if (conta && conta.hasOwnProperty("dadosEa") && conta.dadosEa) {
                $('#imgEscudoClube').attr('src', (conta.dadosEa.img ? conta.dadosEa.img.toString() : "/img/escudo-default.png"));
                $('#infoClube').html(conta.dadosEa.clubeName ? conta.dadosEa.clubeName : 'Clube');
                $('#infoCoins, .info-coins, #infoCoinsTotais').html(conta.dadosEa.coins ? conta.dadosEa.coins.toLocaleString('pt-BR') : 0);
                $('.sem-configuracao').hide();
                $('.com-configuracao').show();
            } else {
                $('.sem-configuracao').show();
                $('.com-configuracao').hide();
            }
        }

        private getPlayers(metodoCallback: any) {
            $.getJSON("/players.json", { _: new Date().getTime() }, (data) => {
                BotConta.players = data.Players;
                metodoCallback();
            });
        }
        private getModoPotente(): number {
            return $("#modoPotente").length && $("#modoPotente").is(":checked") ? 2 : 1;
        }

        private aoClicarEmIniciarSniper(e: JQueryEventObject) {
            console.log("aoClicarEmIniciarSniper");
            this.inicializarTentativas();
            this.inicializarViewQuantidadeCompras();
            this.elBtSnipar.exibirLoading();
            Util.exibirLoadingSniperApp();
            var objFuncaoSniper = this.obterFiltroEConfiguracao(this.elFormSniper);
            this.sniperLogs.exibirLog("Iniciou Sniper", `Seu Sniper foi iniciado`, "primary")
            var request: IRequest = {
                conta: this.conta,
                headless: Util.getModoheadless(),
                modo: this.getModoPotente(),
                sessionId: this.sessionId,
                funcao: null //{ id: Util.FUNCAO_SNIPER, data: objFuncaoSniper }
            };
            console.log("🚀 ~ file: BotConta.ts ~ line 215 - request", request);
            this.comunicacao.enviar(Comunicacao.REQUEST_INICIAR_CONTA, request, (response: IRespostaMensagem) => {
                if (response.status) {
                    this.sessionId = response.result.sessionId;
                    console.log("INICIOU CONTA::", this.sessionId, response)
                    toastr.success("Sniper foi Iniciado.", "Iniciou!");
                }
            })
        }
        private aoClicarEmPararSniper(e: JQueryEventObject) {
            this.elBtPararSniper.exibirLoading();
            var { id, email } = this.conta;
            console.log("aoClicarEmPararSniper", { id, email });
            this.comunicacao.enviar(Comunicacao.REQUEST_PAUSAR_CONTA, { id, email }, (response: IRespostaMensagem) => {
                if (response.status) {
                    this.pararSniper();
                }
            })
        }

        private pararSniper() {
            this.sniperLogs.exibirLog("Sniper Parou", `Seu Sniper terminou de executar `, "danger")
            this.elBtSnipar.ocultarLoading();
            this.elBtPararSniper.ocultarLoading();
            Util.ocultarLoadingSniperApp();
            this.sniperLogs.ocultarLoadLog();
            Util.pararCronometro(App.BotConta.cronometro);
        }

        private aoClicarEmFecharSniper(e: JQueryEventObject) {
            this.elBtFecharSniper.exibirLoading();
            var { id, email } = this.conta;
            console.log("aoClicarEmFecharSniper", { id, email });
            this.comunicacao.enviar(Comunicacao.REQUEST_PARAR_CONTA, { id, email }, (response: IRespostaMensagem) => {
                if (response.status) {
                    this.sniperLogs.exibirLog("WebApp Desconectado", `Seu webapp foi fechado `, "danger")
                    this.elBtSnipar.ocultarLoading();
                    this.elBtFecharSniper.ocultarLoading();
                    Util.ocultarLoadingSniperApp();
                }
            })
        }

        private obterFiltroEConfiguracao(form: JQuery): IFuncaoSniperOptions {
            var objFuncaoSniper: IFuncaoSniperOptions = {}
            var dadosFormulario: any = form.serializeObject();

            objFuncaoSniper.porcentagem_eficacia = null;
            objFuncaoSniper.tempo_minimo_eficacia = null;
            objFuncaoSniper.intervalo = parseInt(dadosFormulario.intervalo)
            objFuncaoSniper.tempo = parseInt(dadosFormulario.tempo)
            objFuncaoSniper.velocidade = parseInt(dadosFormulario.velocidade)
            objFuncaoSniper.descanso = parseInt(dadosFormulario.descanso)
            objFuncaoSniper.limite_compra = parseInt(dadosFormulario.limite_compra)

            objFuncaoSniper.filtros = [];
            dadosFormulario.maskedDefId = dadosFormulario.hasOwnProperty('maskedDefId') ? dadosFormulario.maskedDefId : null;
            dadosFormulario = _.mapObject(dadosFormulario, function (val: any, key: any) {
                return $.isNumeric(val) ? parseInt(App.Util.obterSomenteNumerosDaString(val)) : (Util.empty(val) ? null : (val == "on" ? true : val));
            });

            var { maskedDefId, quality, rarity, position, chemical, nation, league, club, minBid, maxBid, minBuyNow, maxBuyNow, lucro } = dadosFormulario;
            var filtro: any = { maskedDefId, quality, rarity, position, chemical, nation, league, club, minBid, maxBid, minBuyNow, maxBuyNow, lucro };
            var venda: IVenda = null;
            if (this.filtrosEa.elAtivarVendaAutomatica.is(":checked")) {
                var venda: IVenda = {
                    duracao: 3600,
                    valorLanceMinimo: Util.empty(dadosFormulario.valor_lance_minimo) ? null : dadosFormulario.valor_lance_minimo,
                    valorVenda: Util.empty(dadosFormulario.valor_venda) ? null : dadosFormulario.valor_venda,
                    precoFutbin: Util.empty(dadosFormulario.precoFutbin) ? null : dadosFormulario.precoFutbin,
                    porcentagemMaisBarato: Util.empty(dadosFormulario.porcentagemMaisBarato) ? null : dadosFormulario.porcentagemMaisBarato,
                    precoInteligente: Util.empty(dadosFormulario.precoInteligente) ? null : dadosFormulario.precoInteligente
                }

            }

            var novoFiltro: IFiltroOptions = { id: null, nome: null, data: filtro, venda: venda };
            objFuncaoSniper.filtros.push(novoFiltro)

            return objFuncaoSniper
        }
        private receberStatusExecucao(request: IRequestStatusFuncionamento) {
            let elementoLinhaConta = $('#conta' + request.conta.id);
            var dadosFuncionamento: IFuncionamentoAtual = request.data;
            if (request.status) {
                this.sniperLogs.exibirLoadLog();
                Util.iniciarCronometro(App.BotConta.cronometro, $('.cronometro .info-tempo'), dadosFuncionamento.tempo / 1000);
            } else {
                this.sniperLogs.ocultarLoadLog();
                Util.pararCronometro(App.BotConta.cronometro);
            }
        }

        private inicializarTentativas() {
            this.tentativaAtual = 0;
            this.atualizarIconeLoadingTentativasSniper("fas fa-plug", 'Estabelecendo comunicação com WEBAPP...');
        }

        private incrementarTentativa(somenteVisual = false, lance = false) {
            this.tentativaAtual += 1;
            $('.tentativas').html(($.isNumeric(this.tentativaAtual) ? this.tentativaAtual : 0).toString());
        }

        private atualizarIconeLoadingTentativasSniper(classe: string, info: string = '') {
            $('.tentativas').html('<i class="' + classe + '" title="' + info + '"></i>');
        }
    }
}
